import { render } from "./BaseConteiner.vue?vue&type=template&id=7988a2e2&scoped=true"
import script from "./BaseConteiner.vue?vue&type=script&lang=js"
export * from "./BaseConteiner.vue?vue&type=script&lang=js"

import "./BaseConteiner.vue?vue&type=style&index=0&id=7988a2e2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7988a2e2"]])

export default __exports__